import { render, staticRenderFns } from "./concludingReview.vue?vue&type=template&id=63826aba&scoped=true&"
import script from "./concludingReview.vue?vue&type=script&lang=js&"
export * from "./concludingReview.vue?vue&type=script&lang=js&"
import style0 from "./concludingReview.vue?vue&type=style&index=0&id=63826aba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63826aba",
  null
  
)

export default component.exports